import { BILLING_ADDRESS_SCOPE } from '../../../../../constants/billing'
import { StreetNumberInstruction } from './StreetNumberInstruction'

export class BillingStreetNumberInstruction extends StreetNumberInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({ label, waitForNoLoaders, value })
    this.name = 'BillingStreetNumber'
    this.scope = BILLING_ADDRESS_SCOPE
  }

  setDefaultValue (params) {
    this.value = this.retrieveStreetNumberFromAddress(params.billingInformation.address)
  }
}
